export const {
  REACT_APP_APPS_DEVELOPER_ID,
  REACT_APP_APP_ID,
  REACT_APP_VERSION,
  REACT_APP_GOOGLE_ANALYTICS_ID,
} = process.env;
